import { createContext } from 'react'

const TourContext = createContext({
  tour: false,
  setTour: (tour: boolean) => {},
})

export default TourContext
